import Chat from "../Assets/chat.jpeg";
export default function YogaSun({ width = 162, height = 98 }) {
  return (
    <div>
      <img src={Chat} width={width} height={height} alt="logo" />
    </div>
  );
}
